import Vue from "vue";
import Vuex from "vuex";

import home from "./home.module";
import auth from "./auth.module";
import article from "./article.module";
import profile from "./profile.module";
import decorations from "./decorations.module";
import adminOptions from "./adminOptions.module";
import decorationMethod from "./decorationmethod.module";
import rollupFees from "./rollupFees.module";
import ecommDisplayNames from "./ecommDisplayNames.module";
import splitShipment from "./splitShipment.module";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        home,
        auth,
        article,
        profile,
        decorations,
        adminOptions,
        decorationMethod,
        rollupFees,
        ecommDisplayNames,
        splitShipment
    }
});
